import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { DOC_STEPS } from 'utils/constants/routes';
import { useAuth } from 'hooks/useAuth/useAuth';

const DocumentsFunnelStep = ({ isActive, stepId, stepTitle }) => {
  const { t } = useTranslation('Documents');
  const history = useHistory();
  const { uuid } = useParams();
  const location = useLocation();
  const handleClick = useCallback(() => {
    history.push(`${DOC_STEPS[stepId](uuid)}${location.search}`);
  }, [history, stepId, uuid, location.search]);
  const { profile } = useAuth();
  const showSteps = !profile;

  return (
    <button
      className={cx('documents-funnel__step', {
        'documents-funnel__step--is-active': isActive,
      })}
      onClick={handleClick}
      data-testid={`documents-funnel__step-button-${stepId}`}
    >
      {showSteps && (
        <span className="documents-funnel__step-number">
          {t(`step${stepId}`)}
        </span>
      )}
      <span className="documents-funnel__step-title">{stepTitle}</span>
    </button>
  );
};

const DocumentsFunnel = ({ className, activeStep }) => {
  const { t } = useTranslation('Documents');

  return (
    <div className={className} data-testid="documents-funnel">
      <div className="documents-funnel">
        <DocumentsFunnelStep
          stepId="1"
          stepTitle={t('billingData')}
          isActive={activeStep === 1}
          on
        />
        <DocumentsFunnelStep
          stepId="2"
          stepTitle={t('documentation')}
          isActive={activeStep === 2}
        />
      </div>
    </div>
  );
};
DocumentsFunnel.propTypes = {
  className: PropTypes.string,
  activeStep: PropTypes.number.isRequired,
};
export default DocumentsFunnel;
